/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profileswitcherlabel2Inputs */

const en_profileswitcherlabel2 = /** @type {(inputs: Profileswitcherlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch profile`)
};

const de_profileswitcherlabel2 = /** @type {(inputs: Profileswitcherlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil wechseln`)
};

/**
* | output |
* | --- |
* | "Switch profile" |
*
* @param {Profileswitcherlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profileswitcherlabel2 = /** @type {((inputs?: Profileswitcherlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profileswitcherlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profileswitcherlabel2(inputs)
	return de_profileswitcherlabel2(inputs)
});
export { profileswitcherlabel2 as "profileSwitcherLabel" }